// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var StretchNormal = /* #__PURE__ */ (function () {
    function StretchNormal() {

    };
    StretchNormal.value = new StretchNormal();
    return StretchNormal;
})();
var StretchUltraCondensed = /* #__PURE__ */ (function () {
    function StretchUltraCondensed() {

    };
    StretchUltraCondensed.value = new StretchUltraCondensed();
    return StretchUltraCondensed;
})();
var StretchExtraCondensed = /* #__PURE__ */ (function () {
    function StretchExtraCondensed() {

    };
    StretchExtraCondensed.value = new StretchExtraCondensed();
    return StretchExtraCondensed;
})();
var StretchCondensed = /* #__PURE__ */ (function () {
    function StretchCondensed() {

    };
    StretchCondensed.value = new StretchCondensed();
    return StretchCondensed;
})();
var StretchSemiCondensed = /* #__PURE__ */ (function () {
    function StretchSemiCondensed() {

    };
    StretchSemiCondensed.value = new StretchSemiCondensed();
    return StretchSemiCondensed;
})();
var StretchSemiExpanded = /* #__PURE__ */ (function () {
    function StretchSemiExpanded() {

    };
    StretchSemiExpanded.value = new StretchSemiExpanded();
    return StretchSemiExpanded;
})();
var StretchExpanded = /* #__PURE__ */ (function () {
    function StretchExpanded() {

    };
    StretchExpanded.value = new StretchExpanded();
    return StretchExpanded;
})();
var StretchExtraExpanded = /* #__PURE__ */ (function () {
    function StretchExtraExpanded() {

    };
    StretchExtraExpanded.value = new StretchExtraExpanded();
    return StretchExtraExpanded;
})();
var StretchUltraExpanded = /* #__PURE__ */ (function () {
    function StretchUltraExpanded() {

    };
    StretchUltraExpanded.value = new StretchUltraExpanded();
    return StretchUltraExpanded;
})();
var StretchPercent = /* #__PURE__ */ (function () {
    function StretchPercent(value0) {
        this.value0 = value0;
    };
    StretchPercent.create = function (value0) {
        return new StretchPercent(value0);
    };
    return StretchPercent;
})();
var showFontStretch = {
    show: function (v) {
        if (v instanceof StretchNormal) {
            return "StretchNormal";
        };
        if (v instanceof StretchUltraCondensed) {
            return "StretchUltraCondensed";
        };
        if (v instanceof StretchExtraCondensed) {
            return "StretchExtraCondensed";
        };
        if (v instanceof StretchCondensed) {
            return "StretchCondensed";
        };
        if (v instanceof StretchSemiCondensed) {
            return "StretchSemiCondensed";
        };
        if (v instanceof StretchSemiExpanded) {
            return "StretchSemiExpanded";
        };
        if (v instanceof StretchExpanded) {
            return "StretchExpanded";
        };
        if (v instanceof StretchExtraExpanded) {
            return "StretchExtraExpanded";
        };
        if (v instanceof StretchUltraExpanded) {
            return "StretchUltraExpanded";
        };
        if (v instanceof StretchPercent) {
            return "(StretchPercent " + (show(v.value0) + ")");
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStretch (line 23, column 10 - line 33, column 60): " + [ v.constructor.name ]);
    }
};
var printFontStretch = function (v) {
    if (v instanceof StretchNormal) {
        return "normal";
    };
    if (v instanceof StretchUltraCondensed) {
        return "ultra-condensed";
    };
    if (v instanceof StretchExtraCondensed) {
        return "extra-condensed";
    };
    if (v instanceof StretchCondensed) {
        return "condensed";
    };
    if (v instanceof StretchSemiCondensed) {
        return "semi-condensed";
    };
    if (v instanceof StretchSemiExpanded) {
        return "semi-expanded";
    };
    if (v instanceof StretchExpanded) {
        return "expanded";
    };
    if (v instanceof StretchExtraExpanded) {
        return "extra-expanded";
    };
    if (v instanceof StretchUltraExpanded) {
        return "ultra-expanded";
    };
    if (v instanceof StretchPercent) {
        return show(v.value0) + "%";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.FontStretch (line 36, column 20 - line 46, column 36): " + [ v.constructor.name ]);
};
var eqFontStretch = {
    eq: function (x) {
        return function (y) {
            if (x instanceof StretchNormal && y instanceof StretchNormal) {
                return true;
            };
            if (x instanceof StretchUltraCondensed && y instanceof StretchUltraCondensed) {
                return true;
            };
            if (x instanceof StretchExtraCondensed && y instanceof StretchExtraCondensed) {
                return true;
            };
            if (x instanceof StretchCondensed && y instanceof StretchCondensed) {
                return true;
            };
            if (x instanceof StretchSemiCondensed && y instanceof StretchSemiCondensed) {
                return true;
            };
            if (x instanceof StretchSemiExpanded && y instanceof StretchSemiExpanded) {
                return true;
            };
            if (x instanceof StretchExpanded && y instanceof StretchExpanded) {
                return true;
            };
            if (x instanceof StretchExtraExpanded && y instanceof StretchExtraExpanded) {
                return true;
            };
            if (x instanceof StretchUltraExpanded && y instanceof StretchUltraExpanded) {
                return true;
            };
            if (x instanceof StretchPercent && y instanceof StretchPercent) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
export {
    StretchNormal,
    StretchUltraCondensed,
    StretchExtraCondensed,
    StretchCondensed,
    StretchSemiCondensed,
    StretchSemiExpanded,
    StretchExpanded,
    StretchExtraExpanded,
    StretchUltraExpanded,
    StretchPercent,
    printFontStretch,
    eqFontStretch,
    showFontStretch
};
